const account = {
  account: 'Compte',
  changeProfilePicture: 'Changer la photo',
  createAnAccount: 'Créer un compte',
  emailAddress: 'Adresse courriel',
  invalidConnection: 'Connexion invalide',
  invalidOtp: 'Code invalide ou expiré',
  login: 'Connexion',
  loginWithGoogle: 'Connexion avec Google',
  logout: 'Déconnexion',
  noAccountFound: 'Aucun compte trouvé pour ce courriel. Créez un compte d\'abord.',
  otpCode: 'Code à usage unique',
  otpSent: 'Un code à usage unique a été envoyé à votre courriel.',
  password: 'Mot de passe',
  profilePicture: 'Photo de profil',
  profilePictureInvalidType: 'Veuillez choisir une image JPEG, PNG, GIF ou WebP.',
  profilePictureUploadFailed: 'Impossible de mettre à jour la photo de profil.',
  removeProfilePicture: 'Supprimer',
  resendCode: 'Renvoyer le code',
  sendCode: 'Envoyer le code',
  signup: 'Créer un compte',
  verifyCode: 'Vérifier le code',
};

export default account;
